import { Decimal128 } from 'proposal-decimal';

export function formatPrice(price: Decimal128) {
  if (price === undefined) {
    return '';
  }

  // Ensure that the cents is rounded, to account for floating point division
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    currencyDisplay: 'narrowSymbol',
  }).format(price.toNumber());
}
